import { useParams } from "react-router-dom";
import { useHostTenant } from "@/context/HostTenantContext";

/**
 * Unified storefront context for pages under the /s/:slug tree.
 *
 * Returns:
 *   slug      — the active studio slug (from the route on the platform host, or
 *               from the resolved custom domain).
 *   isCustom  — true when running on a studio's own custom domain.
 *   sp(sub)   — build a storefront path. On the platform it prefixes
 *               `/s/<slug>`; on a custom domain it stays at the root.
 *                 sp("")         -> "/s/idli" | "/"
 *                 sp("/login")   -> "/s/idli/login" | "/login"
 *                 sp(`/title/${x}`) -> "/s/idli/title/x" | "/title/x"
 *   SB        — raw base string (kept for convenience).
 */
export function useStore() {
  const params = useParams();
  const host = useHostTenant();
  const isCustom = host.mode === "custom";
  const slug = isCustom ? host.slug : params.slug;
  const SB = isCustom ? "" : `/s/${slug}`;
  const sp = (sub = "") => {
    if (isCustom) return sub || "/";
    return `/s/${slug}${sub}`;
  };
  return { slug, isCustom, sp, SB };
}
